import Auth from '@aws-amplify/auth'
import { factorySetStateAction } from 'redux/factory'
import { http, notification } from '../../services/index'
import { newAPIPaths } from '../../config'

const actions = {
  SET_STATE: 'medicalGroup/SET_STATE',
  GET_MEDICAL_GROUPS: 'medicalGroup/GET_MEDICAL_GROUPS',
  GET_MEDICAL_GROUP_DETAILS: 'medicalGroup/GET_MEDICAL_GROUP_DETAILS',
  GET_MEDICAL_GROUP_CLINICS: 'medicalGroup/GET_MEDICAL_GROUP_CLINICS',
  ADD_MEDICAL_GROUP: 'medicalGroup/ADD_MEDICAL_GROUP',
  UPDATE_MEDICAL_GROUP: 'medicalGroup/UPDATE_MEDICAL_GROUP',
  ASSIGN_FACILITIES: 'medicalGroup/ASSIGN_FACILITIES',
}

export const getMedicalGroupsApi = async (payload) =>
  http
    .get(
      newAPIPaths.getMedicalGroupListing,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const getMedicalGroupDetailsApi = async (payload) => {
  const { medicalGroupId } = payload
  return http
    .get(
      newAPIPaths.getMedicalGroupDetails.replace('{medical_group_id}', medicalGroupId),
      null,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })
}

export const addMedicalGroupApi = async (payload) =>
  http
    .post(
      newAPIPaths.addMedicalGroup,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const getMedicalGroupClinisApi = async (payload) =>
  http
    .get(
      newAPIPaths.getMedicalGroupClinics,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const updateMedicalGroupApi = async (payload) => {
  const { medicalGroupId, ...data } = payload
  return http
    .put(
      newAPIPaths.updateMedicalGroup.replace('{medical_group_id}', medicalGroupId),
      data,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })
}

export const assignFacilitiesToMedicalGroupApi = async (payload) => {
  const { medicalGroupId, ...data } = payload
  return http
    .put(
      newAPIPaths.assignFacilitiesToMedicalGroup.replace('{medical_group_id}', medicalGroupId),
      data,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })
}

export const getMedicalGroupsAction = (payload) => ({
  type: actions.GET_MEDICAL_GROUPS,
  payload,
})

export const getMedicalGroupDetailsAction = (payload) => ({
  type: actions.GET_MEDICAL_GROUP_DETAILS,
  payload,
})

export const getMedicalGroupClinics = (payload) => ({
  type: actions.GET_MEDICAL_GROUP_CLINICS,
  payload,
})

export const addMedicalGroupAction = (payload) => ({
  type: actions.ADD_MEDICAL_GROUP,
  payload,
})

export const updateMedicalGroupAction = (payload) => ({
  type: actions.UPDATE_MEDICAL_GROUP,
  payload,
})

export const assignFacilitiesToMedicalGroupAction = (payload) => ({
  type: actions.ASSIGN_FACILITIES,
  payload,
})

export const medicalGroupSetState = factorySetStateAction(actions.SET_STATE)

export default actions
